import { v4 } from 'uuid';

export function newUuid() {
  return v4();
}
